import { MAX_SMALL_SCREEN_SIZE } from "../constants";
import { getFormattedDate } from "./dateHelper";
import { getFormattedCurrency } from "./dateHelper";
import { getRole } from "./roleHelper";
import { getLookupValue } from "./lookupHelper";
import { encrypt } from "./cryptoHelper";
import { useWindowDimensions } from "./windowHelper";
import { getFormattedPhone } from "./formatHelper";

const IsSmallScreen = (windowWidth: number) =>
  windowWidth <= MAX_SMALL_SCREEN_SIZE;

export { IsSmallScreen, getFormattedDate, getFormattedCurrency, getRole, getLookupValue, encrypt, useWindowDimensions, getFormattedPhone };
